// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"715":"list","962":"home","996":"chunk-common"}[chunkId] || chunkId) + "." + {"570":"62940b08","715":"f6be8087","962":"b076926d","996":"100bfc2a"}[chunkId] + ".js";
};